import type { ReactNode } from 'react';
import { useConfig } from '@/config/ConfigProvider';
import { selectAuthAdapter } from './adapters/select-adapter';
import { TestAuthProvider } from './test-auth-provider';
import { isE2ETestMode } from './utils/e2e';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const config = useConfig();

  // Check for E2E test mode (SSR-safe: checks build-time VITE_E2E_TEST_MODE first,
  // then runtime window.__ENV__ if available)
  const isE2EMode = isE2ETestMode();

  // Use test auth provider for E2E tests
  if (isE2EMode) {
    return <TestAuthProvider>{children}</TestAuthProvider>;
  }

  const adapter = selectAuthAdapter({ appConfig: config });

  // Validate configuration in development
  if (import.meta.env.DEV) {
    adapter.validateConfig();
  }

  const { Provider } = adapter;

  return <Provider>{children}</Provider>;
};
